import { SignIn, SignUp } from "@clerk/clerk-react";
import { Box, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useLocation } from "react-router-dom";
import { routes } from "schemas/routes";

import { AuthAction } from "features/Auth/schema";

import { getRedirectUrl } from "../../helpers";

interface Props {
  action: AuthAction;
}

const ProBundleAuth = ({ action }: Props) => {
  const location = useLocation();
  const redirectUrl = getRedirectUrl(routes.proBundle, location);

  const appearance = {
    elements: {
      card: {
        boxShadow: "none",
        border: `1px solid ${grey[300]}`,
      },
    },
  };

  return (
    <Box sx={{ py: 3 }}>
      <Typography textAlign={"center"} gutterBottom>
        <Box component="span" sx={{ fontSize: { xs: 20, md: 30 } }}>
          Create a Bento Account
        </Box>
      </Typography>
      <Typography sx={{ mb: 3 }} textAlign={"center"}>
        If you already have a Bento Account, simply login{" "}
      </Typography>

      <Grid container justifyContent="center">
        {action === AuthAction.SIGN_UP && (
          <SignUp
            appearance={appearance}
            signInUrl={`/${routes.proBundleSignIn}`}
            afterSignUpUrl={redirectUrl}
            afterSignInUrl={redirectUrl}
          />
        )}
        {action === AuthAction.SIGN_IN && (
          <SignIn
            appearance={appearance}
            signUpUrl={`/${routes.proBundleSignUp}`}
            afterSignUpUrl={redirectUrl}
            afterSignInUrl={redirectUrl}
          />
        )}
      </Grid>
    </Box>
  );
};

export default ProBundleAuth;
